import styled from 'styled-components';


export const PackageIndexDrawerWrapper = styled.div`
	padding-top: .5rem;

	.models-group-container {
		margin-bottom: 1rem;
        position: relative;

		.models-group-name {
			text-transform: capitalize;
			font-size: 1.35rem;
			margin-bottom: 0;
            font-weight: ${props => props.theme.FontWeightBold};
            padding: 0 1rem 1rem 1.5rem;
            font-family: 'Inter Tight', sans-serif;
		}

        /* .models-group-toolbar {
            border-top: thin solid ${props => props.theme.BorderColor};
            border-bottom: thin solid ${props => props.theme.BorderColor};
            margin: .25rem 1rem 1rem 1rem;
            padding: .25rem .5rem;
            font-size: .75rem;
            text-transform: uppercase;

            .download-compcards, .send-shortlist {
                cursor: pointer;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                gap: .5rem;
                opacity: .8;
                text-transform: uppercase;

                &:hover {
                    opacity: 1;
                }
            }
        } */

        .models-group-toolbar-icons {
            position: absolute;
            top: .25rem;
            right: 1.15rem;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            gap: 1rem;
            font-size: 1.2rem;

            .download-compcards, .send-shortlist {
                cursor: pointer;
                opacity: .8;

                &:hover {
                    opacity: 1;
                }
                .arrow-down {
                    --fa-primary-color: white;
                    --fa-secondary-color: black;
                    --fa-primary-opacity: 1;
                    --fa-secondary-opacity: 1;
                }
            }
        }

		.models-container {
			display: block;


            .model-cover {
				padding: .5rem 0 .5rem 1.5rem;
                position: relative;
				display: flex;
				justify-content: flex-start;
				align-items: flex-start;
                border-bottom: thin solid ${props => props.theme.BorderColor};

                &:first-child {
                    border-top: thin solid ${props => props.theme.BorderColor};
                }

                &.model-cover-active {
                    background-color: #f5f5f5;
                }

                &:hover {
                    //drop a light and smooth shadow
                    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
                }

				cursor: pointer;

				.model-cover-img {
					display: block;
					position: relative;

					.model-cover-backgroundimg-container {
						width: ${props => props.$itemHeight};
						height: ${props => props.$itemHeight};
						background-size: cover;
						background-position: center center;
						background-repeat: no-repeat;
						transition: all 0.2s linear;
						z-index: 10;
					}

				}

                .favourites-icon-container {
                    position: absolute;
                    right: 1.25rem;
                    top: .5rem;
                    font-size: 1.25rem;

                    opacity: .8;
                    &.transparent {
                        opacity: .4;
                    }

                    &:hover {
                        opacity: 1;
                    }
                }

                .download-icon-container {
                    position: absolute;
                    right: 1.15rem;
                    bottom: .75rem;
                    font-size: 1.25rem;
                    opacity: .8;

                    &:hover {
                        opacity: 1;
                    }

                    .arrow-down {
                        --fa-primary-color: white;
                        --fa-secondary-color: black;
                        --fa-primary-opacity: 1;
                        --fa-secondary-opacity: 1;
                    }
                }

                /* .model-toolbar {
                    font-size: .75rem;

                    .model-download-compcard {
                        cursor: pointer;
                        display: flex;
                        justify-content: flex-start;
                        align-items: center;
                        gap: .5rem;
                        opacity: .8;
                        text-transform: uppercase;

                        &:hover {
                            opacity: 1;
                        }
                    }
                } */

				.model-name-and-features {
					padding-left: 1.5rem;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    align-items: flex-start;
                    width: 100%;
                    min-height: ${props => props.$itemHeight};
                    gap: .25rem;

					.model-name {
						margin-bottom: .5rem;
                        padding-right: 4rem;
						h3 {
							font-size: 1rem;
							font-weight: ${props => props.theme.FontWeightBold};
							line-height: 1.25em;
							text-transform: uppercase;
							margin: 0;
							cursor: pointer;
						}
					}

                    .model-in-group-name {
                        font-size: .75rem;
						line-height: 1.25em;
                        padding-right: 4rem;
                    }

                    .model-additional-info {
						font-size: .75rem;
						line-height: 1.25em;
						display: flex;
						text-transform: uppercase;
						flex-wrap: wrap;

						.model-birthdate {
							padding-right: .4rem;
							em {
								padding-left: .2rem;
								font-style: normal;
								font-weight: ${props => props.theme.FontWeightBold};
							}
						}
                        .model-age {
                            padding-right: .4rem;
                            em {
                                padding-left: .2rem;
                                font-style: normal;
                                font-weight: ${props => props.theme.FontWeightBold};
                            }
                        }
                        .model-customfield {
							padding-right: .4rem;
							em {
								padding-left: .2rem;
								font-style: normal;
								font-weight: ${props => props.theme.FontWeightBold};
							}
						}
					}

					.model-features {
						font-size: .75rem;
						line-height: 1.25em;
						display: flex;
						text-transform: uppercase;
						flex-wrap: wrap;

						.model-feature {
							padding-right: .4rem;
							em {
								padding-left: .2rem;
								font-style: normal;
								font-weight: ${props => props.theme.FontWeightBold};
							}
						}
					}


				}

                    /* modella corrente: intestazione (nome + azioni) e playlist sotto */
                    &.model-cover-expanded {
                        flex-direction: column;
                        align-items: stretch;
                        padding-right: 1.25rem;
                        cursor: default;

                        .model-expanded-header {
                            display: flex;
                            justify-content: space-between;
                            align-items: flex-start;
                            gap: 1rem;
                            padding-bottom: .75rem;

                            .model-name-and-features {
                                flex: 1 1 0;
                                min-width: 0;
                                width: auto;
                                min-height: 0;
                                padding-left: 0;
                                gap: .5rem;

                                .model-name {
                                    margin-bottom: 0;
                                    padding-right: 0;

                                    h3 {
                                        cursor: default;
                                    }
                                }
                            }

                            .model-expanded-actions {
                                display: flex;
                                justify-content: flex-end;
                                align-items: center;
                                gap: 1rem;

                                .favourites-icon-container,
                                .download-icon-container {
                                    position: static;
                                    cursor: pointer;
                                }
                            }
                        }

                        .model-playlists {
                            display: flex;
                            flex-direction: column;
                            gap: .25rem;

                            .model-playlist {
                                display: flex;
                                justify-content: flex-start;
                                align-items: center;
                                gap: 1rem;
                                padding: .25rem;
                                cursor: pointer;

                                &:hover {
                                    background-color: rgba(0, 0, 0, 0.05);
                                }

                                &.model-playlist-active {
                                    background-color: rgba(0, 0, 0, 0.08);

                                    .model-playlist-name {
                                        font-weight: ${props => props.theme.FontWeightBold};
                                    }
                                }

                                .model-playlist-cover {
                                    flex: 0 0 auto;
                                    width: 4.5rem;
                                    height: 4.5rem;
                                    background-size: cover;
                                    background-position: center center;
                                    background-repeat: no-repeat;
                                }

                                .model-playlist-name {
                                    font-size: .85rem;
                                    line-height: 1.25em;
                                    text-transform: uppercase;
                                }
                            }
                        }
                    }
			}
		}
	}


`;
